export class ErrorWithProgramHelp extends Error {
}
